import { render } from "./StaffDatatableTDChairDoctors.vue?vue&type=template&id=be1b66a8"
import script from "./StaffDatatableTDChairDoctors.vue?vue&type=script&lang=js"
export * from "./StaffDatatableTDChairDoctors.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__